import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Glyphicon, Button, Row, Col, Panel, Radio} from 'react-bootstrap'
import ToolTip from '../components/ToolTip.js'
import * as helpers from '../lib/HelperFunctions'
import ClickOutHandler from 'react-onclickout'
import Confirm from 'react-confirm-bootstrap'
import IdeaProfileField from '../components/IdeaProfileField'
import IdeaOwner from '../components/IdeaOwner'
import Logger from '../stores/Logger'
import './css/UserProfile.css'
import './css/TeamProfile.css'

export const shareMode = Object.freeze({
    dontShare: 0,
    shareWithAdmins: 1,
    shareWithTeam: 2,
})

class TeamProfile extends Component {

    constructor(props) {
        super(props)
        this.changeName = this.changeName.bind(this)
        this.onClickOut = this.onClickOut.bind(this)
        this.viewTeam = this.viewTeam.bind(this)
        this.findTeamMember = this.findTeamMember.bind(this)
        this.teamProfileImage = this.teamProfileImage.bind(this)
        this.showTheInput = this.showTheInput.bind(this)
        this.changeSettings = this.changeSettings.bind(this)
        this.state = {
            showInput: false,
            admin: false,
            loadTeam: false,
            name: '',
            url: '',
            newMemberEmail: '',
            check: undefined,
        }
    }
    componentDidMount(){
        const {stores} = this.props
        const {authStore} = stores
        let team = authStore.primaryTeam()
        this.setState({
            name: team.name,
        })
    }
    changeName(e){
        const {stores} = this.props
        const {authStore} = stores
        if(this.state.name !== ''){
            authStore.updateTeamName(this.state.name)
            this.setState({
                showInput: false,
            })
            this.forceUpdate()
        }
    }
    changeSettings(whichTeamPref, sharingOption, teamKey){
        const {stores} = this.props
        const {authStore} = stores
        authStore.updateSettings(whichTeamPref, sharingOption, teamKey)
    }
    changeCheck(e, shouldShare){
        this.setState({check: shouldShare})
    }
    onClickOut(e) {
        this.setState({
            showInput: false,
        })
    }
    onInputChange(value){
        this.setState({
            name: value,
        })
    }
    onPressEnter(e){
        if(e.charCode === 13) {
            e.preventDefault()
            e.stopPropagation()
            this.changeName(e)
        }
    }
    onPressEnterAddTeamMember(e){
        if(e.charCode === 13) {
            e.preventDefault()
            e.stopPropagation()
            this.addTeamMember(e)
        }
    }
    onAddMemberInputChange(value){
        this.setState({
            newMemberEmail: value,
        })
    }
    addTeamMember(e, name){
        const {stores} = this.props
        const {store, authStore, teamStore} = stores
        if(this.state.newMemberEmail !== ''){
            if (helpers.validateEmail(this.state.newMemberEmail)){
                store.infoAlert = 'Adding team member...'

                //validate email is not already a member of this (or another) team
                teamStore.addMemberToTeam(this.state.newMemberEmail, authStore.primaryTeam().key, name)
                .then(res => {
                    Logger.trackEvent('addTeamMember')
                    //FIXME: allow some time to get the user created, then reload
                    this.setState({
                        newMemberEmail: '',
                        loadTeam: false,
                    })
                    window.setTimeout(() => {
                        store.infoAlert = undefined
                        authStore.loadTeam()
                        this.setState({loadTeam: true})
                    }, 6000)
                })
                .catch(err => {
                    Logger.trackEvent('addTeamMemberError','error',err)
                    store.infoAlert = undefined
                    store.errorAlert = err
                    window.setTimeout(() => { store.errorAlert = undefined }, 10000)
                })
            }else{
                Logger.trackEvent('addTeamMemberInvalidEmail')
            }
        }
    }
    removeMember(e,uid){
        const {stores} = this.props
        const {authStore, teamStore} = stores
        Logger.trackEvent('removeMember', 'uid', uid)
        teamStore.removeMemberFromTeam(uid, authStore.primaryTeam().key)
    }
    onNewImage(url){
        const {stores} = this.props
        const {authStore} = stores
        Logger.trackEvent('teamImageUploaded', 'url', url)
        authStore.updateTeamProfileImage(url)
        this.setState({
            url: url,
        })
    }
    onImageRejected(file){
        const {stores} = this.props
        const {store} = stores
        Logger.trackEvent('teamImageRejected', 'file', file)
        store.errorAlert = 'Image file '+file+' not PNG or JPEG format. Please try another image.'
        window.setTimeout(() => { store.errorAlert = undefined }, 5000)
    }
    teamProfileImage(photoURL){
        if(this.state.url === ''){
            return photoURL
        }
        else{
            return this.state.url
        }
    }
    findTeamMember(teamKey, userID){
        const {stores} = this.props
        const {teamStore} = stores
        return teamStore.findTeam(teamKey, userID)
    }
    viewTeam(team, teamName){
        const {stores} = this.props
        const {authStore} = stores
        Logger.trackEvent('viewTeam', 'teamName', teamName)
        let inIdeaPage = false
        authStore.changeTeam(team, inIdeaPage)
        this.setState({
            name: teamName,
        })
    }
    showTheInput(name){
        this.setState({
            showInput: true,
            name: name,
        })
    }
    render() {
        const {stores} = this.props
        const {authStore} = stores
        let team = authStore.auth.primaryTeam
        const user = authStore.authUser()
        //TODO: Same TeamName to assignedTeams as soon as the name change happens
        let name = team.name
        let isTeamAdmin = false
        let teamMemberList = []
        let shouldSearch = []
        let autoShareToggle = shareMode.dontShare
        if(team.hasOwnProperty('autoShare')){
            autoShareToggle = team.autoShare
        }
        let teamPhotoUrl = this.teamProfileImage(team.photoURL)

        if(team.admin){
            //While iterating through each admin, the code also iterates through the members list to find the admin again
            //This is done because the render() function uses team.members list to render the elements but we still need to know who is the admin from that list
            //So we have a list that is identical with positioning [index] to tell which exact member of the team is the admin
            Object.keys(team.admin).forEach((admin, objectIndex) => {
                Object.keys(team.members).forEach((member, memberIndex) => {
                    if (member !== admin && shouldSearch[memberIndex] !== false){
                        teamMemberList[memberIndex] = false
                    }
                    else{
                        shouldSearch[memberIndex] = false
                        teamMemberList[memberIndex] = true
                    }
                })
                if (admin === user.uid){
                    isTeamAdmin = true
                }
            })
        }
        return (
            <div className='teamMembersContainer'>
                <Row className='teamProfileRow'>
                <div>
                    <h1>Team profile info</h1>
                </div>

                <div className='divInlinePhoto' style={{minWidth: '200px'}}>
                    {isTeamAdmin &&
                        <div className='teamLogoImageContainer'>
                            <IdeaProfileField
                                onNewImage={this.onNewImage.bind(this)}
                                onImageRejected={this.onImageRejected.bind(this)}
                                imageUrl={teamPhotoUrl}
                                imageId={1}
                                uploadText={'Change the team photo'}
                                imageHeight={180}
                                square={true}
                            />
                            <span style={{fontSize: 14 + 'px', color: '#e0e0e0', paddingLeft: 15 + 'px'}}>Recommended size: 200x50px</span>
                        </div>
                    }
                    {(!isTeamAdmin && teamPhotoUrl !== undefined) &&
                        <div className='teamLogoImageContainer'>
                            <div>
                                <img className='predo-teamLogoImage' src={teamPhotoUrl} alt='Profile' />
                            </div>
                        </div>
                    }
                </div>

                <div className='divInline'>
                    <div>
                        <h4 style={{display: 'inline-block'}}>Team Name:</h4>
                        {(this.state.showInput && isTeamAdmin) &&
                            <ClickOutHandler onClickOut={this.onClickOut}>
                                <div style={{display: 'inline-block'}}>
                                    <input onKeyPress={(e) => this.onPressEnter(e)} value={this.state.name} style={{height: 34+'px', marginLeft: 5+'px', fontSize: 20}} onChange={e => this.onInputChange(e.target.value)} autoFocus></input>
                                    <Button onClick={(e) => this.changeName(e)} style={{marginTop: -1, backgroundColor: '#ed1558', cursor: 'pointer', color: 'white', marginLeft: 10+'px'}} className='pull-right'>Change name</Button>
                                </div>
                            </ClickOutHandler>
                        }
                        {(!this.state.showInput && isTeamAdmin) &&
                            <div onClick={() => this.showTheInput(name)} style={{display: 'inline-block'}}>
                                <h4 style={{display: 'inline-block', cursor: 'pointer', marginLeft: 5+'px'}}>{name}</h4>
                                <ToolTip style={{display: 'inline-block'}} tipText='Change teams name'>
                                    <Glyphicon glyph='pencil' style={{marginLeft: 5+'px', color:'gray',fontSize:15}}/>
                                </ToolTip>
                            </div>
                        }
                        {(!this.state.showInput && !isTeamAdmin) &&
                            <div style={{display: 'inline-block'}}>
                                <h4 style={{display: 'inline-block', cursor: 'pointer', marginLeft: 5+'px'}}>{name}</h4>
                            </div>
                        }
                    </div>
                </div>
                </Row>
                <Panel header='Team members'>
                    {team.members && Object.keys(team.members).map((memberId,index) =>
                        <Row className='teamMember' key={index}>
                            <Col style={{display: 'inline-block', float: 'left', marginLeft: 10+'px'}}>
                                <IdeaOwner
                                    ownerName={team.users[memberId].displayName}
                                    ownerPhotoURL={team.users[memberId].photoURL}
                                />
                            </Col>
                            <Col className='teamMembersName' style={{display: 'inline-block'}} sm={8}>
                                {teamMemberList[index] === true &&
                                    <div style={{display: 'inline-block', marginLeft: 5+'px'}}>
                                        {memberId === user.uid ? ( <strong>(Admin) </strong>):( <em>(Admin) </em>)}
                                    </div>
                                }
                                {team.users[memberId].displayName ? (
                                    <div style={{display: 'inline-block', marginLeft: 5+'px'}}>
                                        {memberId === user.uid ? (  <strong><span>{team.users[memberId].displayName} &lt;{team.users[memberId].email}&gt;</span></strong>
                                        ):(
                                        <span>{team.users[memberId].displayName} &lt;{team.users[memberId].email}&gt;</span>
                                        )}
                                    </div>
                                ):(
                                    <span>loading...</span>
                                )}
                            </Col>
                            <Col style={{display: 'inline-block'}} className='teamMemberDelete'>
                            {(teamMemberList[index] !== true && isTeamAdmin === true) &&
                                <ToolTip style={{display: 'inline-block'}} tipText='Remove member from team'>
                                 <Confirm
                                    onConfirm={(e) => this.removeMember(e,memberId)}
                                    body='Are you sure you want to remove this team member?'
                                    confirmText='Confirm Removal'
                                    title='Removing team member'>
                                    <Button bsStyle='link' className='removeMemberButton'>
                                        <Glyphicon glyph='remove' style={{marginLeft: 5+'px', color:'red',fontSize:15}}/>
                                    </Button>
                                </Confirm>
                                </ToolTip>
                            }
                            </Col>
                        </Row>,
                    )}
                </Panel>
                {isTeamAdmin &&
                    <Panel header='Invite a new member'>
                        <input
                            onKeyPress={(e) => this.onPressEnterAddTeamMember(e)}
                            value={this.state.newMemberEmail}
                            onChange={e => this.onAddMemberInputChange(e.target.value)}
                            placeholder='colleague@company.com'
                            autoFocus
                            className='memberInput'>
                        </input>
                        <Button
                            onClick={(e) => this.addTeamMember(e, name)}
                            bsStyle='primary'
                            className='memberAddButton'>
                                Add team member
                        </Button>
                    </Panel>
                }
                {isTeamAdmin &&
                <Panel header='Team settings'>
                    <div style={{marginRight: 30+'px', display: 'inline-block'}}>
                        <Radio
                            onClick={() => this.changeSettings('autoShare', shareMode.dontShare, team.key)}
                            checked={autoShareToggle === shareMode.dontShare}
                            name='radioGroup'
                            readOnly
                            style={{paddingBottom: 10+'px'}}
                        >
                        <span>Do not automatically share ideas with anyone</span>
                        </Radio>
                        <Radio
                            onClick={() => this.changeSettings('autoShare', shareMode.shareWithAdmins, team.key)}
                            checked={autoShareToggle === shareMode.shareWithAdmins}
                            name='radioGroup'
                            readOnly
                            style={{paddingBottom: 10+'px'}}
                        >
                        <span>Automatically share new ideas with team admins</span>
                        </Radio>
                        <Radio
                            onClick={() => this.changeSettings('autoShare', shareMode.shareWithTeam, team.key)}
                            checked={autoShareToggle === shareMode.shareWithTeam}
                            name='radioGroup'
                            readOnly
                        >
                        <span>Automatically share new ideas with team</span>
                        </Radio>
                    </div>
                </Panel>
                }
            </div>
        )
    }
}

export default inject("stores")(observer(TeamProfile))



// WEBPACK FOOTER //
// ./src/containers/TeamProfile.js